import { cn } from '~/styles/extended-theme';
import { type PropsWithClassName } from '~/utils/props-with-classname';

interface Props {
  title: string;
  message: string;
  titleClassName?: string;
  messageClassName?: string;
}

export function EmptySetMessage({
  title,
  message,
  titleClassName,
  messageClassName,
  className,
}: PropsWithClassName<Props>) {
  return (
    <div className={cn('flex size-full flex-col items-center justify-center px-6 pb-20', className)}>
      <div className="flex flex-col items-center gap-3">
        <p className={cn('text-h6 font-semibold', titleClassName)}>{title}</p>
        <p className={cn('text-body2', messageClassName)}>{message}</p>
      </div>
    </div>
  );
}
